
// @ts-nocheck


export const localeCodes =  [
  "es",
  "en",
  "pt",
  "zh",
  "fr"
]

export const localeLoaders = {
  es: [
    {
      key: "locale_es_46json_37bbce7d",
      load: () => import("#nuxt-i18n/37bbce7d" /* webpackChunkName: "locale_es_46json_37bbce7d" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_9f5e1850",
      load: () => import("#nuxt-i18n/9f5e1850" /* webpackChunkName: "locale_pt_46json_9f5e1850" */),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_46json_eb6b6151",
      load: () => import("#nuxt-i18n/eb6b6151" /* webpackChunkName: "locale_zh_46json_eb6b6151" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_3676bfd9",
      load: () => import("#nuxt-i18n/3676bfd9" /* webpackChunkName: "locale_fr_46json_3676bfd9" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "es",
      language: "es-ES",
      name: "Español",
      files: [
        {
          path: "/app/i18n/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      language: "en-US",
      name: "English",
      files: [
        {
          path: "/app/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      language: "pt-PT",
      name: "Português",
      files: [
        {
          path: "/app/i18n/locales/pt.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      language: "zh-CN",
      name: "中文",
      files: [
        {
          path: "/app/i18n/locales/zh.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr-FR",
      name: "Français",
      files: [
        {
          path: "/app/i18n/locales/fr.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "es",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "../i18n/locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "es",
    language: "es-ES",
    name: "Español",
    files: [
      {
        path: "/app/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    language: "en-US",
    name: "English",
    files: [
      {
        path: "/app/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    language: "pt-PT",
    name: "Português",
    files: [
      {
        path: "/app/i18n/locales/pt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    language: "zh-CN",
    name: "中文",
    files: [
      {
        path: "/app/i18n/locales/zh.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr-FR",
    name: "Français",
    files: [
      {
        path: "/app/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/